export default "__VITE_ASSET__3704ad2b__"